<template>
  <div>
    <form
      action="/booking/confirm"
      v-on:submit.prevent="submitHandler"
      method="post"
      id="payment-form"
      v-show="!threeD"
      class="form"
    >
      <div>
        <div id="card-element">
          <!-- A Stripe Element will be inserted here. -->
        </div>
        <div class="loading loading--primary" v-if="loading">
          <div class="loading__inner">
            <div class="loading__spinner"></div>
          </div>
        </div>
      </div>

      <!-- Used to display form errors. -->
      <div id="card-errors" v-if="errors.length > 0" role="alert">
        <p v-for="error in errors" v-html="__(error)" :key="error"></p>
      </div>

      <div class="checkout__btn mt-4">
        <div v-if="!loading">
          <button id="btn-stripe-pay" class="button btn btn--quaternary" style="width: 100%">
            {{ __("Pay Now") }}
          </button>

          <apple-pay
            :amount="amount"
            :currency="currency"
            @applePayComplete="checkPaymentStatus"
          ></apple-pay>
        </div>

        <button class="button btn btn--quaternary" disabled v-if="loading"  style="width: 100%">
          {{ __("Pay Now") }}
        </button>
      </div>
    </form>

    <iframe
      :src="threeDurl"
      v-if="threeD && threeDurl"
      style="margin-top: 40px; width: 100%; height: 400px"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    intentUrl: {
      type: String,
      default: "/booking/stripe/intent",
    },
    validationUrl: {
      type: String,
      default: "/booking/validate",
    },
    paymentStatusUrl: {
      type: String,
      default: "/booking/stripe/payment-status",
    },
    redirectToUrl: {
      type: String,
      default: null,
    },
    amount: {
      type: Number,
      default: 1000,
    },
    currency: {
      type: String,
      default: "gbp",
    },
    owner: {
      type: Object,
      required: false,
    },
  },

  data: () => ({
    loading: false,

    stripe: null,
    intentSecret: null,
    elements: null,
    card: null,
    threeD: false,
    threeDurl: false,

    genericErrorMessage: "There was an error processing your payment.",
    paymentStatusMaxAttempts: 60,
    paymentAttempts: 0,

    meta: {
      amount: 1000,
      currency: "gbp",
      owner: {
        name: "",
        email: "",
        phone: "",
        address: {
          line1: "",
          line2: "",
          city: "",
          state: "",
          postal_code: "",
          country: "GB",
        },
      },
    },

    errors: [],
    cardData: {},
  }),

  mounted() {
    this.meta.amount = this.amount;
    this.meta.currency = this.currency;

    if (this.owner) {
      this.meta.owner = this.owner;
    }

    this.startStripe();
  },

  methods: {
    startStripe() {
      let vm = this;
      axios
        .get(vm.intentUrl)
        .then((response) => {
          if (response.data.error) {
            vm.errors.push(response.data.error);
          }

          // If the intent has succeeded then trigger payment complete. This may occur if the user makes payment
          // and then returns to the checkout page for any reason (e.g. reloads the page due to network issue).
          if (
            response.data.intent.status === 'succeeded' ||
            response.data.intent.status === 'processing'
          ) {
            this.$root.checkout.paymentProcessing = true;
            this.loading = true;
            vm.checkPaymentStatus();
            return;
          }

          this.intentSecret = response.data.intent.client_secret;

          // Create a Stripe client.
          this.stripe = window.stripe;

          // Create an instance of Elements.
          this.elements = this.stripe.elements();

          // Custom styling can be passed to options when creating an Element.
          // (Note that this demo uses a wider set of styles than the guide below.)
          let style = {
            base: {
              color: "#32325d",
              lineHeight: "18px",
              fontSmoothing: "antialiased",
              fontSize: "16px",
              "::placeholder": {
                color: "#aab7c4",
              },
            },
            invalid: {
              color: "#fa755a",
              iconColor: "#fa755a",
            },
          };

          // Create an instance of the card Element.
          this.card = this.elements.create("card", { style: style });

          // Add an instance of the card Element into the `card-element` <div>.
          this.card.mount("#card-element");

          this.handlers();
        })
        .catch(function (error) {
          vm.errors = [];
          vm.errors.push(vm.genericErrorMessage);
          vm.loading = false;
        });
    },
    handlers() {
      let vm = this;
      // Handle real-time validation errors from the card Element.
      this.card.addEventListener("change", function (event) {
        vm.errors = [];

        if (event.error) {
          vm.errors.push(event.error.message);
        }
        if (event.complete) {
          vm.cardData = event;
        }
      });
    },
    submitHandler(event) {
      let vm = this;
      this.$root.checkout.paymentProcessing = true;
      this.loading = true;
      this.paymentAttempts = 0;

      event.preventDefault();

      let data = {
        card_post_code: this.cardData?.value?.postalCode,
      };

      axios.post(vm.validationUrl, data).then((response) => {
        if (response.data.redirect) {
          alert(response.data.msg);
          window.location.replace(response.data.redirect);
        } else {
          this.stripe
            .confirmCardPayment(this.intentSecret, {
              payment_method: {
                card: this.card,
                billing_details: vm.meta.owner,
              },
            })
            .then(function (result) {
              if (result.error) {
                vm.errors = [];
                if (
                  result.error.payment_intent.status === 'succeeded' ||
                  result.error.payment_intent.status === 'processing'
                ) {
                    vm.checkPaymentStatus();
                } else{
                    vm.errors.push(result.error.message);
                    vm.loading = false;
                    vm.$root.checkout.paymentProcessing = false;
                }
              } else {
                // ping backend for payment updates
                vm.checkPaymentStatus();
              }
            })
            .catch(function (error) {
              vm.errors = [];
              vm.errors.push(vm.genericErrorMessage);
              vm.loading = false;
              vm.$root.checkout.paymentProcessing = false;
            });
        }
      });
    },
    onPaymentComplete() {
      this.redirectToOrderCompletePage();
    },
    redirectToOrderCompletePage() {
        var vm = this;
        if (this.redirectToUrl) {
            setTimeout(function() {
                window.location.replace(vm.redirectToUrl);
            }, 500);
        } else {
            window.location.replace("/booking/confirm");
        }
    },
    /**
     * This method will repeatedly ping to the backend to check payment status until it returns success
     */
    checkPaymentStatus() {
      var vm = this;
      axios
        .post(vm.paymentStatusUrl)
        .then((response) => {
          if (response.data.complete === true) {
            vm.onPaymentComplete();
          } else {
            setTimeout(() => {
              if (vm.paymentAttempts > vm.paymentStatusMaxAttempts) {
                vm.errors = [];
                vm.errors.push("Timeout processing payment");
                vm.loading = false;
              } else {
                vm.checkPaymentStatus();
                ++vm.paymentAttempts;
              }
            }, 1000);
          }
        })
        .catch(function (error) {
          vm.errors = [];
          vm.errors.push(vm.genericErrorMessage);
          vm.loading = false;
        });
    },
  },
  watch: {
    amount() {
      this.meta.amount = this.amount;
      this.startStripe();
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Gateway/Stripe.vue